<template>
    <div>
    <v-data-table :options.sync="options"
        :server-items-length="totalItems" :footer-props="{
            'items-per-page-options': [15, 50, 100],
            showFirstLastPage: true,
        }" :loading="loading" locale="nl-BE" :items="items" :headers="headers" item-key="time" dense>
        <template v-slot:item.time="{ item }">
            {{ $moment(item.time).tz('UTC').format('DD/MM HH:mm') }}
        </template>
        <template v-slot:item.severity="{ item }">
            <v-chip small :color="Event.getSeverity(item.severity) ? Event.getSeverity(item.severity).color : 'default'" dark>
                {{ Event.getSeverity(item.severity) ? Event.getSeverity(item.severity).text : item.severity }}
            </v-chip>
        </template>
    </v-data-table>
</div>
</template>
<script>
import Event from '../models/event';

export default {
    name: 'eod-logs',
    props: {
        filters: Object
    },
    data: () => ({
        Event: Event,
        items: [],
        headers:[{
            text: 'Tijd',
            value: 'time'
        },
        {
            text: 'Niveau',
            value: 'severity'
        },
        {
            text: 'Bericht',
            value: 'message'
        }],
        totalItems: 0,
                options: {
                    itemsPerPage: 15
                },
                loading: false
    }),
    watch: {
        filters() {
            this.loadLogs();
        },
        options: {
            handler() {
                localStorage.setItem(this.$eod.getUser().id + '-options-alarm-list', JSON.stringify(this.options));
                this.loadLogs();
            },
            deep: true,
        },
    },
    mounted(){
        this.loadLogs();
    },
    methods: {
        loadLogs(){
            if(this.filters){

                const filter = {...this.filters};

                if (this.options.sortBy && this.options.sortBy[0]) {
                        filter.orderBy = {
                            column: this.options.sortBy[0],
                            type: this.options.sortDesc[0] ? 'desc' : 'asc'
                        }
                    }

                    if (this.options.page) {
                        filter.offset = this.options.page - 1;
                    }
                    if (this.options.itemsPerPage && this.options.itemsPerPage >= 0) {
                        filter.limit = this.options.itemsPerPage;
                    }

                    this.loading = true;
                this.$eod.get('logs', ['time', 'message', 'severity'], filter)
                    .then(response => {
                        if(response.data && response.data.data && response.data.data.logs){
                            this.totalItems = response.data.data.logs.totalCount;
                            this.items = response.data.data.logs.edges;
                        }
                    }).finally(() => {
                        this.loading = false;
                    });
            } else {
                console.error('eod-logs: filters required!');
            }
        }
    }
}
</script>